import { render } from "./ConsentView.vue?vue&type=template&id=cb4c0708"
import script from "./ConsentView.vue?vue&type=script&lang=js"
export * from "./ConsentView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__